"use strict";
export { Skeleton, SkeletonCircle, SkeletonPropsProvider, SkeletonText } from './skeleton.js';
